import VoucherGroupDetail from './VoucherGroupDetail';

export default VoucherGroupDetail;



// WEBPACK FOOTER //
// ./src/scenes/StaticVoucherGroups/VoucherGroupDetail/index.ts